import React from 'react';

import { dateService } from '../../../services/date';
import { getClass } from '../../../utils/component-helpers';

import Icon from '../../ui/icon';
import './story.scss';

const Story = ({ story, selectedStory, handleClick, editable, newlyCreated }) => {
  const icon = story.channel ? (
    story.channel === 'youtube' ? (
      <Icon iconName="youtubeLogo" size={23} />
    ) : story.channel === 'instagram' ? (
      <Icon iconName="instagramLogo" size={18} />
    ) : null
  ) : null;

  const selected = selectedStory && selectedStory.edit_id === story.edit_id;

  const selectedIcon = selected ? (
    <span className="radio-btn selected">
      <span className="fill"></span>
    </span>
  ) : null;

  const newChip = newlyCreated ? <span className="new-chip">New Post Created</span> : null;

  const date = story.datetime_created ? dateService.formatDisplayDate(story.datetime_created) : '';

  return (
    <div
      className={getClass('links-story', {
        selected,
        editable,
      })}
      onClick={handleClick}
    >
      <div>
        <div className="name">
          <span>{story.name}</span>
          {newChip}
        </div>
        <div className="icon-date">
          {icon}
          <span className="date">{date}</span>
        </div>
      </div>
      {selectedIcon}
    </div>
  );
};

export default Story;
